import { useCitations } from "@/lib/citations";

interface CitationChipProps {
  index: number;
}

export function CitationChip({ index }: CitationChipProps) {
  const ctx = useCitations();
  if (!ctx || index < 1 || index > ctx.sourcesCount) {
    return <span>{index}</span>;
  }
  return (
    <button
      type="button"
      onClick={() => ctx.highlight(index)}
      aria-label={`Jump to source ${index}`}
      className="ndc-citation-chip mx-[2px] inline-flex h-[18px] min-w-[22px] items-center justify-center rounded-full border border-[var(--accent)]/30 bg-[var(--accent-soft)] px-[6px] align-[2px] text-[11px] font-medium text-accent leading-none transition-colors hover:bg-accent hover:text-accent-fg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent"
    >
      {index}
    </button>
  );
}
